// extracted by mini-css-extract-plugin
export var modalFooter = "_sg-0";